/**************************************************************************************************/
/*   File: /src/app/stores/selectors/creation/selectors.ts                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Apr 17 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducers from '../../reducers/creation';
import * as fromStates from '../../states/creation';
import { DossierContent } from '../../../shared/models';

/**
 * Get the dossier creation State
 */
export const getDossierCreationState = createFeatureSelector<fromStates.CreationState>('creation');

/**
 * Selector for is Loading property
 */
export const getIsLoading = createSelector(
  getDossierCreationState,
  fromReducers.helpers.getIsLoading
);
/**
 * Selector for messages array
 */
export const getMessages = createSelector(
  getDossierCreationState,
  fromReducers.helpers.getMessages
);
/**
 * Selector for plan types array
 */
export const getDossierId = createSelector(
  getDossierCreationState,
  fromReducers.helpers.getDossierId
);
/**
 * Selector for dossier content
 */
export const getDossierContent = createSelector(
  getDossierCreationState,
  fromReducers.helpers.getDossierContent
);
/**
 * Selector used to check if plan code is set
 */
export const isSetPlanCode = createSelector(
  getDossierContent,
  (dossierContent) => {
    return dossierContent !== undefined && dossierContent.planCode !== undefined;
  }
);
/**
 * Selector used to check if ambito code is set
 */
export const isSetAmbitoCode = createSelector(
  getDossierContent,
  (dossierContent) => {
    return dossierContent !== undefined
      && dossierContent.territorialAreasCodes !== undefined
      && dossierContent.territorialAreasCodes.length > 0;
  }
);
/**
 * Selector used to check if spatial data type is set
 */
export const isSetSpatialDataType = createSelector(
  getDossierContent,
  (dossierContent) => {
    return dossierContent !== undefined && dossierContent.defaultSpatialDataType !== undefined;
  }
);
/**
 * Selector to extract the spatial dossier checker
 */
export const isSpatialDossier = createSelector(
  getDossierContent,
  (dossierContent) => {
    return dossierContent !== undefined && dossierContent.spatialDossier;
  }
);
/**
 * Selector to check the regulations dossier checker
 */
export const isRegulationsDossier = createSelector(
  getDossierContent,
  (dossierContent) => {
    return dossierContent !== undefined && dossierContent.regulationsDossier;
  }
);
/**
 * Get the ambiti
 */
export const getAmbiti = createSelector(
  getDossierCreationState,
  fromReducers.helpers.getAmbiti
);